import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchProfileName(profileId) {
  const id = profileId && { profileId };
  return axiosRequest('post', serviceUrls.PROFILE_GET_NAME, id);
}

export function fetchProfileDetail(profileId) {
  const id = profileId && { profileId };
  return axiosRequest('post', serviceUrls.PROFILE_GET_DETAILS, id);
}

export function updateProfileDetail(body = {}) {
  return axiosRequest('post', serviceUrls.PROFILE_SAVE_DETAILS, body);
}

export function getProfileContactEmploymentHistoryApi(request) {
  return axiosRequest('get', serviceUrls.PROFILE_GET_CONTACT_EMPLOYMENT_HISTORY, { contactEmploymentHistoryId: request.entityId });
}

export function upsertProfileContactEmploymentHistoryApi(data) {
  return axiosRequest('post', serviceUrls.PROFILE_UPSERT_CONTACT_EMPLOYMENT_HISTORY, data);
}

export function upsertProfileContactEmploymentHistorySalaryApi(data) {
  return axiosRequest('post', serviceUrls.PROFILE_UPSERT_CONTACT_EMPLOYMENT_HISTORY_SALARY, data);
}

export function getRelationshipContact(relationshipId) {
  return axiosRequest('post', serviceUrls.PROFILE_GET_RELATIONSHIP_CONTACT, { relationshipId });
}
